import React from 'react';
import classnames from 'classnames';
import styles from './FiltersBar.module.scss';

export interface FiltersBarProps {
  children?: React.ReactNode,
  className?: string,
}

const FiltersBar = ({className, children}: FiltersBarProps) => {
  return (
    <div className={classnames(styles.filtersBarContainer, className)}>
      {children}
    </div>
  );
};

export default FiltersBar;
